import { Component } from '@angular/core';

@Component({
        selector: 'settings',
        template:`
        <p>settings</p>

    `,
    styles: ['.example-card { max-width: 300px; }']
  })
export class SettingsComponent {

  title: string = 'Settings';
}
